import React, { Component } from 'react'
import { get } from 'lodash'
import { PropTypes } from 'prop-types'
import { connect } from 'react-redux'
import { Select } from 'components/fields'
import { apiOrganizations } from 'helpers/decorators/api'
import { organizationsCodeListDropdownSelector } from 'redux/selectors/organizations'
import queryString from 'query-string'

@apiOrganizations({
  codeList: true,
  filter: 'awardUnitsOrIacs'
})
@connect(state => ({
  awardUnitsAndIacs: organizationsCodeListDropdownSelector(state)
}))
class AjEventAwardUnit extends Component {
  static propTypes = {
    location: PropTypes.object.isRequired,
    awardUnitsAndIacs: PropTypes.array.isRequired,
    values: PropTypes.object,
    initialize: PropTypes.func.isRequired
  }

  componentDidMount = () => {
    const query = queryString.parse(get(this.props, 'location.search'))

    this.handleInitForm(get(query, 'organizationId'))
  }

  componentWillReceiveProps = nextProps => {
    const { awardUnitsAndIacs } = this.props

    if (
      awardUnitsAndIacs.length === 0 &&
      nextProps.awardUnitsAndIacs.length > 0
    ) {
      this.handleInitForm(get(nextProps.location, 'query.organizationId'))
    }
  }

  mapTransportationMode = (transportationModes) => {
    const transportationModeList = transportationModes && transportationModes.map(item => {
      return {
        id: get(item, 'transportationMode.id'),
        value: get(item, 'transportationMode.modeOfTransportType.value'),
        label: get(item, 'transportationMode.modeOfTransportType.translationText')
      }
    })

    return transportationModeList
  }

  handleInitForm = orgId => {
    if (!orgId) {
      return
    }

    const data = {
      ...this.props.values,
      assignToOrganizationId: Number(orgId),
      transportationModes: this.mapTransportationMode(get(this.props, 'ajEvents.detail.transportationModes'))
    }

    this.props.initialize(data)
  }

  render() {
    const { awardUnitsAndIacs } = this.props

    return (
      <Select
        name="assignToOrganizationId"
        label="For Award Unit"
        intlKey="label.for_award_unit"
        options={awardUnitsAndIacs}
        searchable
      />
    )
  }
}

export default AjEventAwardUnit
